import * as React from 'react';
const SvgBookOpen = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M22 6.67a.6.6 0 0 0-.09-.21c-.26-.44-.66-.85-1.18-1.22s-1.141-.67-1.842-.9a7.4 7.4 0 0 0-2.29-.34c-.981 0-1.882.17-2.692.5-.81.34-1.44.77-1.891 1.31-.46-.53-1.09-.97-1.9-1.31-.811-.34-1.702-.5-2.682-.5a7.4 7.4 0 0 0-2.301.34q-1.063.345-1.841.9c-.52.37-.91.78-1.18 1.22-.051.08-.081.14-.091.21-.01.06-.02.13-.02.21v11.69c0 .36.1.61.31.76.2.15.44.22.71.22.15 0 .3-.04.44-.11s.3-.16.471-.26c.5-.32 1.04-.58 1.63-.76.571-.18 1.171-.27 1.782-.27h.05c.65 0 1.28.12 1.9.35.621.23 1.181.58 1.692 1.04.2.17.37.29.53.36s.32.1.49.1.32-.03.48-.1.33-.19.53-.36c.5-.47 1.071-.81 1.691-1.04s1.261-.35 1.911-.35h.05q.915 0 1.771.27c.59.19 1.14.44 1.631.76.17.1.32.19.47.26.14.07.29.11.45.11.26 0 .5-.07.7-.22s.311-.4.311-.76V6.88c0-.07 0-.14-.02-.21zm-11.996 9.95c-.83-.31-1.7-.47-2.581-.48h-.07c-.81 0-1.611.12-2.382.36-.33.1-.65.23-.96.36v-9.6c.12-.13.27-.27.46-.4.35-.25.78-.46 1.28-.62C6.263 6.08 6.833 6 7.444 6c.71 0 1.35.12 1.91.35.51.21.901.47 1.141.76l.52.61v9.38a7 7 0 0 0-1.01-.47zm10.015.25q-.465-.21-.96-.36-1.155-.36-2.372-.36h-.07a7.5 7.5 0 0 0-3.602.95V7.73l.53-.63c.24-.29.621-.54 1.131-.75.56-.23 1.2-.35 1.921-.35q.915 0 1.681.24c.5.16.94.37 1.29.62q.27.195.451.39z"
    />
  </svg>
);
export default SvgBookOpen;
